module.exports = ".wrapper{\r\n    width: 100%;\r\n    background: rgba(233, 226, 226, 0.267);\r\n}\r\n.main-panel{\r\n    position: absolute;\r\n    width: 80%;\r\n    right: 0px;\r\n}\r\n.sidebar{\r\n    position: absolute;\r\n    width: 20%;\r\n    height: 100%;\r\n    \r\n    background: rgba(145, 133, 133, 0.267);\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main